import React from "react";

interface UploadCommonModalProps {
  onSubmit: (file: File) => void;
  handleClose: () => void;
  handleEmptyTemplate:  () => void;
  title: string;
}

const UploadCommonModal: React.FC<UploadCommonModalProps> = ({ onSubmit,handleEmptyTemplate, handleClose, title }) => {
  const handleSubmit = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onSubmit(file);
      handleClose();
    }
  };

  return (
    <div className="fixed inset-0 mt-20 z-50 flex items-start justify-center p-10 bg-black bg-opacity-30">
      <div className="bg-white w-[750px] max-w-full h-[70vh] overflow-auto rounded-lg shadow-lg p-4">
        <div className="flex items-center justify-between border-b pb-2 mb-4">
          <h2 className="text-xl font-semibold text-gray-700">{title}</h2>
          <button onClick={handleClose} className="text-gray-500 hover:text-gray-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-x-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M15 9L9 15" />
              <path d="M9 9l6 6" />
            </svg>
          </button>
        </div>

        <div className="flex justify-center">
          <label
            htmlFor="dropzone-file"
            className="flex flex-col items-center justify-center w-full h-64 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors"
          >
            <div className="flex flex-col items-center justify-center p-6">
              <svg
                className="w-8 h-8 mb-4 text-gray-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5A5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              <p className="mb-2 text-sm text-gray-500">
                <span className="font-semibold">Click to {title}</span> or drag and drop
              </p>
              <p className="text-xs text-gray-400">Accepted formats: CSV, PDF, SVG, PNG, JPG, GIF</p>
            </div>
            <input
              id="dropzone-file"
              type="file"
              className="hidden"
              onChange={handleSubmit}
              accept=".csv,.pdf,.svg,.png,.jpg,.jpeg,.gif"
            />
          </label>
        </div>
          
          <div className="flex justify-end items-center p-4">
  <button
    onClick={handleEmptyTemplate}
    className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
  >
    <span>Template Download</span>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
    <path d="M12 14.5L12 4.5M12 14.5C11.2998 14.5 9.99153 12.5057 9.5 12M12 14.5C12.7002 14.5 14.0085 12.5057 14.5 12" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
  </button>
</div>


      </div>

    </div>
  );
};

export default UploadCommonModal;
